import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import StudioHome from './StudioHome';
import StudioEditorPage from './StudioEditorPage';

const DEFAULT_BASE_PATH = '/franchise-dashboard/branding-marketing/studio';

const StudioRouter = ({
  firebase,
  authUser,
  brandingContext,
  brandingContextLoading,
  basePath = DEFAULT_BASE_PATH,
}) => (
  <Switch>
    <Route exact path={basePath}>
      <StudioHome
        firebase={firebase}
        authUser={authUser}
        brandingContext={brandingContext}
        brandingContextLoading={brandingContextLoading}
      />
    </Route>
    <Route path={`${basePath}/editor/:projectId`}>
      <StudioEditorPage
        firebase={firebase}
        brandingContextLoading={brandingContextLoading}
      />
    </Route>
    <Redirect to={basePath} />
  </Switch>
);

export default StudioRouter;
